import {LOG_LEVEL} from '@/shared/config';
import {ConsoleTransport, Logger, RollbarTransport} from '@/shared/lib/logger';

export {RollbarTransport, ConsoleTransport};

export const logger = new Logger({
  level: LOG_LEVEL,
  transports: [new ConsoleTransport()],
});
